import * as React from 'react';

// Components
import { IconNotification20 } from '@nebula/icon';
import { Tip } from '@shopee-user/shared-customization-ui';

// Hook
import { useTranslation } from '@shopee-user/platform';

// Hoc
import { withUserWebView } from '@shopee-user/with-web-view';

// Constants
import { config } from '@shopee-user/platform';
import { Env } from '@shopee-user/global';

// Types
import { SupportedLocale } from '@shopee-user/spx-customization-logic';
import { WithUserWebViewProps } from '@shopee-user/with-web-view';

import styles from './style.scss';

const ENTERPRISE_ACCOUNT_SIGNUP_LINK_MAP: Record<
  SupportedLocale,
  Record<Env, string>
> = {
  SG: {
    [Env.Live]: '',
    [Env.Liveish]: '',
    [Env.Stable]: '',
    [Env.Staging]: '',
    [Env.Uat]: '',
    [Env.Test]: '',
  },
  VN: {
    // TODO: check with PM if we need to separate link for non-live and live env to aovid test data affect live data
    [Env.Live]:
      'https://spx.vn/dangky-dichvu-vanchuyen?utm_source=website&utm_medium=&utm_campaign=NSS-signup&utm_content=tai-day',
    [Env.Liveish]:
      'https://spx.vn/dangky-dichvu-vanchuyen?utm_source=website&utm_medium=&utm_campaign=NSS-signup&utm_content=tai-day',
    [Env.Stable]:
      'https://test.spx.vn/dangky-dichvu-vanchuyen?utm_source=website&utm_medium=&utm_campaign=NSS-signup&utm_content=tai-day',
    [Env.Staging]:
      'https://test.spx.vn/dangky-dichvu-vanchuyen?utm_source=website&utm_medium=&utm_campaign=NSS-signup&utm_content=tai-day',
    [Env.Uat]:
      'https://test.spx.vn/dangky-dichvu-vanchuyen?utm_source=website&utm_medium=&utm_campaign=NSS-signup&utm_content=tai-day',
    [Env.Test]:
      'https://test.spx.vn/dangky-dichvu-vanchuyen?utm_source=website&utm_medium=&utm_campaign=NSS-signup&utm_content=tai-day',
  },
  TH: {
    [Env.Live]: 'https://spx.co.th/interest-form',
    [Env.Liveish]: 'https://spx.co.th/interest-form',
    [Env.Stable]: 'https://spx.co.th/interest-form',
    [Env.Staging]: 'https://spx.co.th/interest-form',
    [Env.Uat]: 'https://spx.co.th/interest-form',
    [Env.Test]: 'https://spx.co.th/interest-form',
  },
  ID: {
    [Env.Live]: '',
    [Env.Liveish]: '',
    [Env.Stable]: '',
    [Env.Staging]: '',
    [Env.Uat]: '',
    [Env.Test]: '',
  },
  BR: {
    [Env.Live]: '',
    [Env.Liveish]: '',
    [Env.Stable]: '',
    [Env.Staging]: '',
    [Env.Uat]: '',
    [Env.Test]: '',
  },
  PH: {
    [Env.Live]: 'https://spx.ph/interest-form',
    [Env.Liveish]: 'https://spx.ph/interest-form',
    [Env.Stable]: 'https://staging.spx.ph/interest-form',
    [Env.Staging]: 'https://staging.spx.ph/interest-form',
    [Env.Uat]: 'https://uat.spx.ph/interest-form',
    [Env.Test]: 'https://test.spx.ph/interest-form',
  },
  MY: {
    [Env.Live]: 'https://spx.com.my/interest-form',
    [Env.Liveish]: 'https://spx.com.my/interest-form',
    [Env.Stable]: 'https://spx.com.my/interest-form',
    [Env.Staging]: 'https://staging.spx.com.my/interest-form',
    [Env.Uat]: 'https://uat.spx.com.my/interest-form',
    [Env.Test]: 'https://test.spx.com.my/interest-form',
  },
};

const ENTERPRISE_ACCOUNT_SIGNUP_LINK =
  ENTERPRISE_ACCOUNT_SIGNUP_LINK_MAP[config.LOCALE as SupportedLocale][
    config.ENV as Env
  ] || '';

function SignupByOtpTip({
  webViewNavigateToUrl,
  onClick,
}: WithUserWebViewProps & { onClick?: () => void }) {
  const I18n = useTranslation();
  return (
    <>
      {!!ENTERPRISE_ACCOUNT_SIGNUP_LINK && (
        <Tip
          icon={<IconNotification20 color="#f69113" />}
          title={I18n.t('label_auth_are_you_an_enterprise_account')}
          type="caution"
          className={styles.tipContainer}
        >
          <div className={styles.tipDescription}>
            {I18n.tNode(
              'label_auth_please_submit_an_interest_form_for_more_support',
              {
                submit_form: (
                  <a
                    className={styles.link}
                    onClick={ev => {
                      ev.preventDefault();
                      onClick && onClick();
                      webViewNavigateToUrl(ENTERPRISE_ACCOUNT_SIGNUP_LINK);
                    }}
                  >
                    {I18n.t('label_auth_submit_form')}
                  </a>
                ),
              }
            )}
          </div>
        </Tip>
      )}
    </>
  );
}

export default withUserWebView({})(SignupByOtpTip);
